import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

const ICON_BY_TYPE = {
    'Círculo': 'fa-circle',
    'Retângulo': 'fa-square',
    'Polígono': 'fa-draw-polygon',
};

const isCircle = (shape) => shape.type === 'Círculo';

function RadiusPopover({ shape, onSetRadius }) {
    const [radius, setRadius] = useState(Math.round(shape.radiusMeters || 0));

    const popover = (
        <Popover id={`popover-raio-${shape.drawId}`}>
            <Popover.Title as="h3">Editar Raio do Círculo (m)</Popover.Title>
            <Popover.Content>
                <div className="d-flex align-items-center" style={{ gap: 6 }}>
                    <input
                        type="number"
                        min="1"
                        className="form-control form-control-sm"
                        value={radius}
                        onChange={(e) => setRadius(e.target.value)}
                        style={{ width: 110 }}
                    />
                    <button
                        title="Salvar"
                        className="btn btn-success btn-sm"
                        onClick={() => onSetRadius(shape, parseFloat(radius))}
                    >
                        <i className="fa-solid fa-check"></i>
                    </button>
                </div>
            </Popover.Content>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" placement="top" rootClose overlay={popover}>
            <button className="btn btn-default btn-sm" title="Alterar Raio do Círculo">
                <i className="fa-solid fa-up-right-and-down-left-from-center"></i>
            </button>
        </OverlayTrigger>
    );
}

function ShapeItem({ shape, onCenter, onRename, onToggleVisibility, onSetRadius, onEditAttributes, onRemove }) {
    const [editing, setEditing] = useState(false);
    const [name, setName] = useState(shape.name);

    const commitRename = () => {
        setEditing(false);
        onRename(shape, name);
    };

    return (
        <li className="list-group-item d-flex justify-content-between align-items-center" style={{ gap: 8 }}>
            <div style={{ fontWeight: 'bold', minWidth: 0, flex: 1 }}>
                <i className={`fa-solid ${ICON_BY_TYPE[shape.type] || ''}`} style={{ color: shape.color }}></i>{' '}
                {editing ? (
                    <input
                        autoFocus
                        className="form-control form-control-sm d-inline-block"
                        style={{ width: '70%' }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') commitRename(); if (e.key === 'Escape') { setName(shape.name); setEditing(false); } }}
                        onBlur={commitRename}
                    />
                ) : (
                    <span style={{ opacity: shape.visible ? 1 : 0.5 }}>{shape.name}</span>
                )}
            </div>

            <div className="btn-group" style={{ gap: 4 }} role="group">
                <button className="btn btn-default btn-sm" title="Centralizar Mapa na Forma" onClick={() => onCenter(shape)}>
                    <i className="fa-solid fa-bullseye"></i>
                </button>

                <button className="btn btn-default btn-sm" title="Renomear Forma" onClick={() => { setName(shape.name); setEditing(true); }}>
                    <i className="fa-regular fa-pen-to-square"></i>
                </button>

                {onEditAttributes && (
                    <button className="btn btn-default btn-sm" title="Editar Atributos da Forma" onClick={() => onEditAttributes(shape)}>
                        <i className="fa-solid fa-sliders"></i>
                    </button>
                )}

                <button
                    className="btn btn-default btn-sm"
                    title={shape.visible ? 'Esconder' : 'Mostrar'}
                    onClick={() => onToggleVisibility(shape)}
                >
                    <i className={`fa-solid ${shape.visible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                </button>

                {isCircle(shape) && <RadiusPopover shape={shape} onSetRadius={onSetRadius} />}

                <button className="btn btn-default btn-sm" title="Remover" onClick={() => onRemove(shape)}>
                    <i className="far fa-trash-alt"></i>
                </button>
            </div>
        </li>
    );
}

export default function DrawnShapesList({ shapes, onCenter, onRename, onToggleVisibility, onSetRadius, onEditAttributes, onRemove }) {
    if (!shapes || shapes.length === 0) return null;

    return (
        <ul className="list-group">
            {shapes.map((shape) => (
                <ShapeItem
                    key={shape.drawId}
                    shape={shape}
                    onCenter={onCenter}
                    onRename={onRename}
                    onToggleVisibility={onToggleVisibility}
                    onSetRadius={onSetRadius}
                    onEditAttributes={onEditAttributes}
                    onRemove={onRemove}
                />
            ))}
        </ul>
    );
}
